import { WinGISMap } from "../../createMap";
import {identify }  from "@arcgis/core/rest/identify.js";

import { getIdentifyParameters } from "./getIdentifyParameters";

export async function GetResult(paramObj, layer){
  return identify(layer.url, paramObj).then((result) => {
    result.originLayer = layer.title;
    return result;
  })
}

export async function GetResults(event, params) {
  const identifyPromises = [];
  for (const layer of WinGISMap.map.layers) {
    if (layer.visible && layer.type === "map-image") {
      let paramObj = await getIdentifyParameters(event, layer, params);

      if (paramObj !== false && paramObj.layerIds.length > 0) {
        identifyPromises.push(GetResult(paramObj, layer)); 
      }
    }
  }
  const identifyResults = await Promise.all(identifyPromises);
  return identifyResults;
}